import { reactive } from 'vue'
import { ConfirmOptions } from '@/types/plugins/confirm'

const confirmList = reactive<ConfirmOptions[]>([])

const confirmPlugin = () => {
  const add = (
    options: Omit<ConfirmOptions, 'id'> & Partial<Pick<ConfirmOptions, 'id'>>
  ) => {
    confirmList.push({ id: options.id || Date.now().toString(), ...options })
  }
  const remove = (id: string) => {
    confirmList.splice(
      confirmList.findIndex((item) => item.id === id),
      1
    )
  }

  return {
    add,
    remove,
  }
}

confirmPlugin.value = confirmList

export default {
  install: (app: any) => {
    app.config.globalProperties.$confirm = confirmPlugin
  },
}

export type ConfirmPlugin = typeof confirmPlugin
